import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import { format } from 'date-fns';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function PeriodManagement() {
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    TypePeriod: '',
    TypePeriodTo: ''
  });

  useEffect(() => {
    fetchPeriods();
  }, []);

  const fetchPeriods = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/indent/periods`);
      setPeriods(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching periods:', err);
      setError('Failed to load indent periods');
      setLoading(false);
    }
  };

  const handleEdit = (period) => {
    setEditingId(period.TypeID);
    setEditForm({
      TypePeriod: format(new Date(period.TypePeriod), 'yyyy-MM-dd'),
      TypePeriodTo: format(new Date(period.TypePeriodTo), 'yyyy-MM-dd')
    });
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditForm({
      TypePeriod: '',
      TypePeriodTo: ''
    });
  };

  const handleUpdate = async (typeId) => {
    try {
      await axios.put(`${API_BASE_URL}/indent/periods/${typeId}`, editForm);
      setEditingId(null);
      fetchPeriods();
    } catch (err) {
      console.error('Error updating period:', err);
      setError('Failed to update period');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) return <div className="text-center py-4">Loading...</div>;
  if (error) return <div className="text-center text-red-500 py-4">{error}</div>;

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Manage Indent Periods</h2>
          
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Type Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Start Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    End Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {periods.map((period) => (
                  <tr key={period.TypeID}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {period.TypeName}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {editingId === period.TypeID ? (
                        <input
                          type="date"
                          name="TypePeriod"
                          value={editForm.TypePeriod}
                          onChange={handleInputChange}
                          className="border rounded px-2 py-1"
                        />
                      ) : (
                        format(new Date(period.TypePeriod), 'MMM dd, yyyy')
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {editingId === period.TypeID ? (
                        <input
                          type="date"
                          name="TypePeriodTo"
                          value={editForm.TypePeriodTo}
                          onChange={handleInputChange}
                          className="border rounded px-2 py-1"
                        />
                      ) : (
                        format(new Date(period.TypePeriodTo), 'MMM dd, yyyy')
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {editingId === period.TypeID ? (
                        <div className="space-x-2">
                          <button
                            onClick={() => handleUpdate(period.TypeID)}
                            className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                          >
                            Save
                          </button>
                          <button
                            onClick={handleCancel}
                            className="bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-600"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => handleEdit(period)}
                          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PeriodManagement;